//
export const AuthenUserMock = {
  user: {
    username: 'dulich102_ketoan',
    password: 'dulich102_ketoan@',
    accountType: 'NHAN_VIEN'
  },
  loginResponse: {
    token: 'ey...',
    user: {
      id: '12398415936892',
      image: '',
      ho_ten: 'nguyenthilan',
      email: 'nguyenthilan@gmail.com',
    },
    menu: [5001,6,1,2,3,4,5,7,8,9,10,11],
  },
  appKey: 'MOBILE_HUTECH',
};

// 5001,6,1,2,3,4,5,7,8,9,
// export const AuthenUserMock = {
//   user: {
//     username: 'NNV0050588',
//     password: '123qwe@..',
//     accountType: 'NHAN_VIEN'
//   },
//   loginResponse: {
//     token: 'ey...',
//     user: {
//       id: '12398415936892',
//       image: '',
//       ho_ten: 'Developer',
//       email: 'Developer@gmail.com',
//     },
//     menu: [300038, 300036, 300037, 300039],
//   },
//   appKey: 'MOBILE_HUTECH',
// };
